<template>
  <section class="container">
    <h1 class="mb-1e is-size-3">Tabela terenów</h1>
    <table class="table w-100">
      <tr
        class="card-wrap"
        v-for="(card, key, index) in sorted"
        :key="`card-${key}`">
        <td>{{index+1}}</td>
        <th>{{card.id}}</th>
        <td>{{card.name.replace(/\|/g, ' ')}}</td>
      </tr>
    </table>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    showNv: true,
  }),
  computed: {
    ...mapGetters({
      all: 'allTerritories',
      grouped: 'GROUPED_NVS',
    }),
    allKeys() {
      return Object.keys(this.all);
    },
    sorted() {
      const list = {};
      const sorted = this.sortKeys(this.allKeys);

      sorted.forEach((key) => {
        list[key] = this.all[key];
      });

      return list;
    },
  },
  methods: {
    sortKeys(keys) {
      return keys.sort((a, b) => {
        const idA = this.all[a].id.split('-');
        const idB = this.all[b].id.split('-');

        const { length: lenA } = idA;
        const { length: lenB } = idB;

        if (lenA === 1 || lenB === 1) {
          if (lenA !== lenB) {
            return lenB - lenA;
          }

          const numA = parseInt(idA[0], 10);
          const numB = parseInt(idB[0], 10);

          if (numA !== numB) {
            return numA - numB;
          }

          return 0;
        }

        if (idA[0] !== idB[0]) {
          return idA[0] < idB[0] ? -1 : 1;
        }

        const numA = parseInt(idA[1], 10);
        const numB = parseInt(idB[1], 10);

        if (numA !== numB) {
          return numA - numB;
        }

        return 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.field {
  width: 100%;
  max-width: 40rem;
}

.label {
  margin-bottom: .5rem;
}

@media print {
  h1,
  .settings {
    display: none;
  }

  .card-wrap {
    page-break-after: always;
  }
}
</style>
